import React from 'react';
import { pains } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function PainSection() {
  return <section aria-labelledby="pain-title" className="bg-teal-tint py-12 md:py-20" data-id="element-180" data-mp="38xetd8zbufpu">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-181" data-mp="2uxdq5mvlaw77">
        <SectionHeading id="pain-title" eyebrow={pains.eyebrow} title={pains.title} data-id="element-182" data-mp="2yzh4cj9n8ew6" />

        <ul className="mt-8 grid gap-3 sm:grid-cols-2 md:mt-12 md:gap-4 lg:grid-cols-3" data-id="element-183" data-mp="2z1lf9l5yme5y">
          {pains.items.map(item => <li key={item.title} className="rounded-xl border border-teal-tintLine bg-white p-5 md:p-6" data-id="element-184" data-mp="2pzc8n6dtb4xu">
              <span className="mb-3 block h-1 w-8 rounded-full bg-orange" aria-hidden="true" data-id="element-185" data-mp="2baxy09a5mc6q" />
              <h3 className="font-display text-[16px] font-extrabold uppercase leading-snug tracking-tight text-teal md:text-[17px]" data-id="element-186" data-mp="2g8hms34ha7cx">
                {item.title}
              </h3>
              <p className="mt-2 text-[16px] leading-relaxed text-ink/75" data-id="element-187" data-mp="278bb8mscbhge">{item.text}</p>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-[760px] text-center font-display text-[1.25rem] font-extrabold uppercase leading-tight tracking-tight text-orange-ink md:text-[1.7rem]" data-id="element-188" data-mp="3rlzjrimv2bqi">
          {pains.bridge}
        </p>
      </div>
    </section>;
}